import {IFieldMeta} from 'entities/metadata';
import {selectContextRawData} from 'modules/context/context-selector';
import {selectEntityData, TEntityValue} from 'modules/data';
import {selectReferenceEntityData} from 'modules/data/data-selectors';
import {IFilterEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {selectUserInfo} from 'store/slices/auth-slice';

export enum EDefaultValueRuleType {
    USER_TAX_PERIOD = 'userTaxPeriod',
    USER_ORGANIZATION = 'userOrganization',
    CURRENT_DATE = 'currentDate',
    CURRENT_USER = 'currentUser',
    FILTER_VALUE = 'filterValue',
    DEFAULT_LOOK_UP_VALUE = 'defaultLookUpValue'
}

export const useDefaultValueByRule = (
    entityName: string,
    fieldMeta: IFieldMeta | undefined,
) => {
    const currentUser = useAppSelector(selectUserInfo);
    const context: TEntityValue = useAppSelector(selectContextRawData);
    const filter = useAppSelector(selectEntityData(entityName, EEntityType.FILTER)) as IFilterEntityData;
    const referenceOptions = useAppSelector(selectReferenceEntityData(fieldMeta?.referenceUrl || ''));

    const selectedFilterData: any = filter?.data?.[fieldMeta?.dependentInputKey || ''];

    const getDefaultValue = () => {
        switch (fieldMeta?.defaultValueByRule) {
        case EDefaultValueRuleType.USER_TAX_PERIOD:
            return context?.taxPeriodId || undefined;

        case EDefaultValueRuleType.USER_ORGANIZATION:
            return context?.organizationId || undefined;

        case EDefaultValueRuleType.CURRENT_DATE:
            return new Date();

        case EDefaultValueRuleType.CURRENT_USER:
            return currentUser?.fullName;

        case EDefaultValueRuleType.FILTER_VALUE:
            return referenceOptions?.find(
                option => (option?.lookupCode === selectedFilterData?.lookupCode
                    && option?.id === selectedFilterData?.id) || option?.id === selectedFilterData,
            );

        case EDefaultValueRuleType.DEFAULT_LOOK_UP_VALUE:
            // attribute1 - дефолтное значение для поля monitorProgramId в directories.type.documents
            return referenceOptions?.find(option => !!option?.isDefault
                || (option?.attribute1 && option?.attribute1 === 'Y'));

        default:
            return undefined;
        }
    };

    return {
        getDefaultValue,
    };
};
